import "swagger-ui-react/swagger-ui.css"
import React from 'react';
import Router from "./pages/Router";
import "@elcimai/webankdesignsystem/dist/style.css";
import bundle from "@elcimai/webankdesignsystem/dist/img/bundle.svg"
import {IconConfig} from "@elcimai/webankdesignsystem";
import Theme from "./hooks/useTheme";

IconConfig.bundle = bundle

function App() {
    return (
        <Theme>
                <Router/>
        </Theme>
    )
}

export default App
